/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IdentityParams { 
    /**
     * The create identity transaction signed with the subject private key. This transaction must contain the subject public key to store it on the blockchain. Encoded in Base64 format
     */
    signedCreateIdentityTransaction: IdentityParams.SignedCreateIdentityTransactionEnum;
    /**
     * The create identity transaction signed with the subject private key. This transaction must contain the subject public key to store it on the blockchain. Encoded in Base64 format
     */
    subjectPublicKey: IdentityParams.SubjectPublicKeyEnum;
}
export namespace IdentityParams {
    export type SignedCreateIdentityTransactionEnum = '[B@3ab6678b';
    export const SignedCreateIdentityTransactionEnum = {
        B3ab6678b: '[B@3ab6678b' as SignedCreateIdentityTransactionEnum
    };
    export type SubjectPublicKeyEnum = '[B@7a904f32';
    export const SubjectPublicKeyEnum = {
        B7a904f32: '[B@7a904f32' as SubjectPublicKeyEnum
    };
}


